"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eps = 1e-6; // 精度
function feq(a, b) {
    return Math.abs(a - b) < exports.eps;
}
exports.feq = feq;
